import api from "@/config/api";
import { Forms } from "@/types/form";
import { log } from "@/utils/logger";

const usePasswordResetLink = () => {
    const onPasswordResetLink = async (data: Forms["PasswordResetLink"]) => {
        try {
            await api.post("/users/reset-password", { data, authenticate: false });

            log.success(
                "If you have an account with us, you should receive an email with instructions.",
            );
        } catch (e) {
            log.error(e, "onResetPassword");
        }
    };

    return onPasswordResetLink;
};

export { usePasswordResetLink };
